// Video
export default class Video {
  constructor(TARGET = ".js-video-btn") {
    this.target = TARGET; // ターゲット要素
    const videoBtn = document.querySelectorAll(TARGET);

    videoBtn.forEach((a) => {
      a.addEventListener("click", (e) => {
        let videoID = sanitize(e.currentTarget.getAttribute("data-video"));
        if (videoID) {
          const YOUTUBE = /(youtube(-nocookie)?\.com|youtu\.be)\/(watch\?v=|v\/|u\/|embed\/?)?([\w-]{11})(.*)?/i;
          const youtube_uri = YOUTUBE.exec(videoID);
          let iframe = "";
          iframe += '<div class="c-frame-wrapper">';
          //youtubeiframe挿入
          iframe += setFrame(
            appendQueryParams(
              "https://www.youtube" + (youtube_uri[2] || "") + ".com/embed/" + youtube_uri[4],
              //youtubeのオプションを記述
              Object.assign(
                {
                  rel: 0,
                  autoplay: 1,
                },
                parseQueryParams(youtube_uri[5] || "")
              )
            )
          );
          iframe += "</div>";
          e.currentTarget.insertAdjacentHTML("afterEnd", iframe);
          e.currentTarget.classList.add("is-play");
        }

        //IDメモリ解放
        videoID = null;
      });
    });

    // サニタイズ
    function sanitize(str) {
      return String(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    //Youtube用
    function setFrame(target) {
      return '<iframe frameborder="0" allow="autoplay; fullscreen" src="' + target + '"/>';
    }

    function parseQueryParams(params) {
      var pairs = decodeURI(params.split("#")[0]).split("&");
      var obj = new Map();
      var p;

      for (var i = 0, n = pairs.length; i < n; i++) {
        if (!pairs[i]) {
          continue;
        }

        p = pairs[i].split("=");
        obj.set(p[0], p[1]);
      }

      return obj;
    }

    function appendQueryParams(url, params) {
      const keys = Object.keys(params);
      const query = keys.map((key) => `${key}=${params[key]}`).join("&");
      return `${url}${url.includes("?") ? "&" : "?"}${query}`;
    }
  }
}
